export default __webpack_public_path__ + "static/media/win.74e90e9a.jpg";